import Clarity from '@microsoft/clarity';

export function useClarity() {
    const clarityIdentify = (userId, friendlyName) => {
        Clarity.identify(userId, null, null, friendlyName);
    };

    return {
        clarityIdentify,
    };
}
